var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('div',{ref:"telegram"})])
}
var staticRenderFns = []

export { render, staticRenderFns }